import { applyContentClip, contentClipRect } from './contentClip.js';

/**
 * The child mask used by an openHASP `obj` container.  It is the same
 * rectangular widget mask used by gauge/linemeter internal content.
 */
export function objChildClipRect(width, height) {
  return contentClipRect(width, height);
}

/** Apply the LVGL-equivalent child clip to an obj Group. */
export function applyObjChildClip(node) {
  if (!node || node.obj !== 'obj') return false;

  const rect = applyContentClip(node,
    typeof node.width === 'function' ? node.width() : node.width,
    typeof node.height === 'function' ? node.height() : node.height,
  );
  return rect;
}

/**
 * Run hit drawing without the visual child mask.  This keeps children that
 * extend outside an obj selectable and draggable, while scene drawing stays
 * clipped.  Transformer handles are rendered by the layer-level Transformer
 * and are therefore unaffected by the parent clip.
 */
export function withoutObjChildClip(node, drawHit) {
  if (!node || node.obj !== 'obj' || typeof drawHit !== 'function') {
    return drawHit?.();
  }

  const saved = {
    clipX: node.clipX(),
    clipY: node.clipY(),
    clipWidth: node.clipWidth(),
    clipHeight: node.clipHeight(),
  };

  node.setAttrs({ clipX: undefined, clipY: undefined, clipWidth: undefined, clipHeight: undefined });
  try {
    return drawHit();
  } finally {
    node.setAttrs(saved);
  }
}
